import { CartProps } from "shared/interfaces/ICart";

/** "Cor: Azul · Tamanho: 10,50 cm"; vazio para produto sem variações. */
export function textoVariacoes(item: Pick<CartProps, "variacoes">): string {
  return (item.variacoes ?? [])
    .map((variacao) => `${variacao.name}: ${variacao.value}`)
    .join(" · ");
}
